import { datesToISO, parseBoolean } from "@";

//search values payload
export const searchValuesPayload = (page, pageSize, search) => {
  const parseArray = (value) => (value ? [parseInt(value)] : []);
  const parseIntOrNull = (value) => (value ? parseInt(value) : null);

  return {
    page,
    pageSize,
    searchKey: search.title,
    banksIds: parseArray(search.bank),
    isPaid: parseBoolean(search.isPaid),
    projectIds: parseArray(search.project),
    amountTo: parseIntOrNull(search.toAmount),
    dateTo: datesToISO(search.toDate) || null,
    accountsIds: parseArray(search.bankAccount),
    amountFrom: parseIntOrNull(search.fromAmount),
    dateFrom: datesToISO(search.fromDate) || null,
    affiliatesIds: parseArray(search.affiliateUser),
    paymentType: parseIntOrNull(search.paymentType),
    projectClassificationIds: parseArray(search.donationType),
    classificationId: parseIntOrNull(search.classificationId),
  };
};

export const mapSelectsOptions = (data, labelKey = "name") =>
  Array.isArray(data)
    ? data.map((option) => ({
        value: option.id,
        label: option[labelKey],
      }))
    : [];
